export default "__VITE_ASSET__B_T6exVt__"